import {Fragment} from 'react';
import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text/text';
import type {OverrideSelectRowProps, OverrideSelectSection} from '../../ai-chat-super-user-options.types';
import styles from './super-user-override-select.module.scss';

export function SuperUserOverrideSelect({id, label, value, sections, onChange}: OverrideSelectRowProps): ReactElement {
  return (
    <div className={styles.overrideSelect}>
      <label htmlFor={id}>
        <Text val={label} size={TextSize.SM} className={styles.overrideLabel} />
      </label>
      <select id={id} className={styles.overrideField} value={value} onChange={onChange}>
        {sections.map((section, index) => renderSection(section, index))}
      </select>
    </div>
  );
}

function renderSection(section: OverrideSelectSection, index: number): ReactElement {
  const rows = section.options.map((option) => (
    <option key={option.value} value={option.value}>
      {option.label}
    </option>
  ));

  if (section.heading === null) {
    return <Fragment key={`ungrouped-${index}`}>{rows}</Fragment>;
  }

  return (
    <optgroup key={section.heading} label={section.heading}>
      {rows}
    </optgroup>
  );
}
